// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__16y4C","title":"AfterFrontImage_title__2tuT3"};